import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-body" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black" };
const _hoisted_12 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputRow = _resolveComponent("InputRow");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.assigned_worker_catch_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formattedHubConfigurationAssignedWorkerCatchYn), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.sort_by_code`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.validatedHubConfigurationSortByCode), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.kilometer_product_all_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formattedHubConfigurationKilometerProductAllYn), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.kilometer_product_range`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formattedHubConfigurationKilometerProduct), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}worker_one_click_baecha_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedWorkerOneClickBaechaYn), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.share_call_color_type`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formattedHubConfigurationShareCallColorType), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.assigned_worker_lock_time`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formattedHubConfigurationAssignedWorkerLockTime), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.order_show_time`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formattedHubConfigurationOrderShowTime), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.options.is_double_click_prevention`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedHubConfigurationOptionsIsDoubleClickPrevention), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.options.is_assigned_worker_catch_hidden`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formattedHubConfigurationOptionsIsAssignedWorkerCatchHidden), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_configuration.options.is_allocated_after_cancel`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formattedHubConfigurationOptionsIsAllocatedAfterCancel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
